import { render, staticRenderFns } from "./Statuscomerciais.vue?vue&type=template&id=01f256d8&scoped=true"
import script from "./Statuscomerciais.vue?vue&type=script&lang=js"
export * from "./Statuscomerciais.vue?vue&type=script&lang=js"
import style0 from "./Statuscomerciais.vue?vue&type=style&index=0&id=01f256d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f256d8",
  null
  
)

export default component.exports